// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@layer defaults {
  :root {
    --readthedocs-search-font-family: var(--readthedocs-font-family);
    --readthedocs-search-font-size: var(--readthedocs-font-size); /* 16px? */
    --readthedocs-search-code-font-family:
      SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New",
      monospace;
    --readthedocs-search-code-font-size: 0.9em;

    --readthedocs-search-backdrop-color: rgba(0, 0, 0, 0.3);
    --readthedocs-search-color: rgb(64, 64, 64);
    --readthedocs-search-link-color: rgb(64, 64, 64);

    --readthedocs-search-content-background-color: #fcfcfc;
    --readthedocs-search-content-border-color: #e0e0e0;
    --readthedocs-search-filters-border-color: #e0e0e0;
    --readthedocs-search-footer-background-color: rgb(234, 234, 234);
    --readthedocs-search-footer-color: #404040;
    --readthedocs-search-footer-code-background-color: #fff;
    --readthedocs-search-footer-code-border-color: #e1e4e5;
    --readthedocs-search-input-background-color: #eaeaea;

    /* \`--readthedocs-search-result-section-highlight-color\` is deprecated but
     * still support it for now. */
    --readthedocs-search-result-highlight-color: var(
      --readthedocs-search-result-section-highlight-color,
      #6ea0ec
    );
    --readthedocs-search-result-background-color: initial;
    /* \`--readthedocs-search-result-section-color\` is deprecated but
     * still support it for now. */
    --readthedocs-search-result-color: var(
      --readthedocs-search-result-section-color,
      rgba(0, 0, 0, 0.54)
    );
    --readthedocs-search-result-icon-color: rgba(0, 0, 0, 0.54);
    --readthedocs-search-result-heading-color: rbg(0, 0, 0);
    /* \`--readthedocs-search-result-section-subheading-color\` is deprecated but
     * still support it for now. */
    --readthedocs-search-result-subheading-color: var(
      --readthedocs-search-result-section-subheading-color,
      rgba(0, 0, 0, 0.64)
    );
    --readthedocs-search-result-active-background-color: rgb(245, 245, 245);
    --readthedocs-search-result-border-color: rgb(224, 224, 224);
    --readthedocs-search-badge-background-color: #e5f6ff;
    --readthedocs-search-badge-color: rgba(0, 0, 0, 0.75);
  }
}

:host > div {
  font-family: var(--readthedocs-search-font-family);
  font-size: var(--readthedocs-search-font-size);

  /* TODO: make some of this variables */
  color: var(--readthedocs-search-color);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 3000;
  line-height: 1rem;
}

:host > div a {
  color: var(--readthedocs-search-link-color);
  text-decoration: none;
  cursor: pointer;
}

:host > div code {
  background: var(--readthedocs-search-footer-code-background-color);
  padding: 2px 5px;
  border: solid 1px var(--readthedocs-search-footer-code-border-color);
  color: var(--readthedocs-search-color);
  white-space: pre-wrap;
  word-wrap: break-word;
  font-family: var(--readthedocs-search-code-font-family);
  font-size: var(--readthedocs-search-code-font-size);
  border-radius: 0;
}

:host > div .background {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1250;
  width: 100%;
  height: 100%;
  background-color: var(--readthedocs-search-backdrop-color);
  backdrop-filter: blur(3px);
}

:host > div > div.content {
  margin: 5em auto auto auto;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 100000;
  height: 80%;
  width: 60%;
  max-width: 43em;
  overflow-y: hidden;
  display: flex;
  flex-direction: column;
  border: 1px solid var(--readthedocs-search-content-border-color);
  border-radius: 0.7rem;
  line-height: 1.75rem;
  background-color: var(--readthedocs-search-content-background-color);
  box-shadow:
    rgba(0, 0, 0, 0.05) 5px 5px 5px 5px,
    rgba(0, 0, 0, 0.05) -5px -5px 5px 5px;
  text-align: left;
}

:host > div form {
  background-color: var(--readthedocs-search-input-background-color);
  margin: 0.5em;
  border-radius: 0.25em;
  font-size: 1.05em;
  padding: 5px;
  display: flex;
}

:host > div form.focus {
  outline: 2px solid #6ea0ec;
  border-shadow: inset 0 0 1px white transparent;
}

:host > div form > label {
  font-size: 1.15em;
  padding-left: 5px;
  color: var(--readthedocs-search-color);
}

:host > div form label svg {
  height: 1em;
  position: relative;
  top: 5px;
}

:host > div form > input {
  border: 0;
  outline: none;
  background: inherit;
  width: max-content;
  font-size: 1.15em;
  box-shadow: none;
  width: 100%;
  padding: 6px;
  line-height: 1;
  color: var(--readthedocs-search-color, rgb(64, 64, 64));
}

:host > div .results {
  margin-top: 10px;
  padding: 0.5em;
  overflow-y: scroll;
  height: 100%;
  hyphens: auto;
}

div.hit-block {
  padding-top: 3px;
  border-top: 1px solid var(--readthedocs-search-result-border-color);
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
  background-color: var(--readthedocs-search-result-background-color);
}

div.hit-block a.hit-block-heading {
  display: flex;
  align-items: center;
  width: 100%;
}

div.hit-block .hit-block-heading-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

div.hit-block .hit-block-heading-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5em;
  width: 100%;
  min-width: 0;
}

div.hit-block .hit-block-heading-row h2 {
  flex-shrink: 0;
  min-width: 0;
}

div.hit-block a.hit-block-heading i,
div.hit-block .hit-block-heading-container .close-icon {
  font-size: 1.15em;
  width: 1em;
  padding-right: 10px;
  color: var(--readthedocs-search-result-icon-color);
  padding-top: 5px;
}

button.close-icon {
  border: none;
  margin: 0;
  padding: 0;
  padding-right: 10px;
  margin-bottom: 15px;
  overflow: visible;

  display: inline-block;
  width: 1em;
  height: 1em;
  vertical-align: middle;

  background: transparent;
  cursor: pointer;
}

button.close-icon svg {
  pointer-events: none;
}

div.hit-block a.hit-block-heading i svg,
div.hit-block .hit-block-heading-container svg {
  width: 1em;
}

:host > div .results a.hit {
  width: 100%;
  display: inline-block;
  padding: 0.15em calc(1.15em + 10px);
  box-sizing: border-box;
}

:host > div .results a.hit:hover,
:host > div .results .hit .active {
  background-color: var(--readthedocs-search-result-active-background-color);
}

:host > div .results h2 {
  display: inline-block;
  font-weight: 700;
  margin-top: 3px;
  margin-bottom: 5px;
  font-size: 1em;
  color: var(--readthedocs-search-result-heading-color);
  line-height: inherit;
}

:host > div .results a.hit > div {
  display: flex;
  flex-direction: column;
}

:host > div .results .hit .subheading {
  color: var(--readthedocs-search-result-subheading-color);
  font-weight: 700;
  font-size: 15px;
  margin-right: 10px;
  overflow-x: hidden;
  margin: inherit;
  line-height: inherit;
}

:host > div .results .project-badge {
  align-items: center;
  background-color: var(--readthedocs-search-badge-background-color);
  border-radius: 999px;
  color: var(--readthedocs-search-badge-color);
  display: inline-flex;
  font-size: 0.85em;
  font-weight: 600;
  line-height: 1;
  padding: 0.25em 0.6em;
  white-space: nowrap;
  flex-shrink: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}

:host > div .results .hit .content {
  margin: 0;
  text-decoration: none;
  color: var(--readthedocs-search-result-color);
  font-size: 15px;
  display: block;
  margin-bottom: 5px;
  margin-bottom: 0;
  line-height: inherit;
  text-align: left;
}

:host > div .results span {
  font-style: normal;
}

:host > div .results .hit h2 span {
  background-color: #e5f6ff;
  padding-bottom: 3px;
  border-bottom-color: black;
}

:host > div .results .hit span {
  color: var(--readthedocs-search-result-highlight-color);
  font-style: italic;
  font-weight: bold;
}

:host div.content > div.footer {
  width: 100%;
  display: inline-block;
  height: 30px;
  background-color: var(--readthedocs-search-footer-background-color);
  color: var(--readthedocs-search-footer-color);
}

:host > div .credits {
  float: right;
  margin: 0 15px;
  font-size: small;
  padding-top: 3px;
}

:host > div .credits a img {
  display: inline-block;
  width: 100px;
  vertical-align: middle;
}

/* TODO: find an example for domain role and style it properly */
:host > div .readthedocs-search-result-hit--domain-role {
  font-size: 80%;
  letter-spacing: 1px;
}

:host > div .filters-title {
  display: block;
  font-size: 0.9rem;
  position: absolute;
  top: 0;
  left: 14px;
  background: rgb(252, 252, 252);
  margin: 0 5px;
  padding: 0 5px;
}

:host > div .filters {
  position: relative;
  padding-top: 0.9rem;
  margin: 0 0.5em;
}

:host > div .filters ul {
  display: block;
  margin: 0;
  padding: 5px 14px;
  border-radius: 0.3rem;
  border-style: solid;
  border-width: 1px;
  border-color: var(--readthedocs-search-filters-border-color);
  border-bottom: 1px solid #e0e0e0;
}

:host > div .filters li {
  display: inline-block;
  margin: 0 0 0 15px;
}

:host > div .filters li input {
  vertical-align: middle;
}

:host > div .filters li label {
  padding: 3px;
  cursor: pointer;
}

:host > div .filters label {
  font-size: 0.9rem;
}

:host > div .no-results {
  text-align: center;
  margin-top: 1.15em;
  padding: 15px;
  margin: 0 auto;
  width: 80%;
}

:host > div .no-results > p.title {
  margin-top: 0;
  margin-bottom: 0.5em;
}

:host > div .no-results > svg {
  height: 5.5rem;
  margin-bottom: 1.15em;
}

:host > div .no-results > div.footer p {
  font-size: small;
}

:host > div .no-results > .tips {
  padding: 0;
  text-align: left;
  font-size: 15px;
  margin-bottom: 1.15em;
}

:host > div .no-results > .tips ul {
  padding: 0 0 0 0.7em;
  margin: 0;
}
:host > div .no-results > .tips li {
  list-style-position: inside;
  list-style-type: "\\BB  ";
  margin: 0;
  color: var(--readthedocs-search-color);
}

:host > div .help {
  display: inline-block;
  font-size: small;
  margin: 0 15px;
  padding: 0;
}

:host > div .help li {
  list-style: none;
  display: inline-block;
  margin: 0 0.4em;
}
`, "",{"version":3,"sources":["webpack://./src/search.css"],"names":[],"mappings":"AAAA;EACE;IACE,gEAAgE;IAChE,4DAA4D,EAAE,UAAU;IACxE;;eAEW;IACX,0CAA0C;;IAE1C,uDAAuD;IACvD,2CAA2C;IAC3C,gDAAgD;;IAEhD,sDAAsD;IACtD,kDAAkD;IAClD,kDAAkD;IAClD,gEAAgE;IAChE,0CAA0C;IAC1C,uDAAuD;IACvD,sDAAsD;IACtD,oDAAoD;;IAEpD;kCAC8B;IAC9B;;;KAGC;IACD,qDAAqD;IACrD;kCAC8B;IAC9B;;;KAGC;IACD,2DAA2D;IAC3D,uDAAuD;IACvD;kCAC8B;IAC9B;;;KAGC;IACD,uEAAuE;IACvE,4DAA4D;IAC5D,oDAAoD;IACpD,qDAAqD;EACvD;AACF;;AAEA;EACE,kDAAkD;EAClD,8CAA8C;;EAE9C,sCAAsC;EACtC,sCAAsC;EACtC,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,2CAA2C;EAC3C,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,kEAAkE;EAClE,gBAAgB;EAChB,oEAAoE;EACpE,sCAAsC;EACtC,qBAAqB;EACrB,qBAAqB;EACrB,uDAAuD;EACvD,mDAAmD;EACnD,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,aAAa;EACb,WAAW;EACX,YAAY;EACZ,0DAA0D;EAC1D,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,eAAe;EACf,WAAW;EACX,UAAU;EACV,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,gEAAgE;EAChE,qBAAqB;EACrB,oBAAoB;EACpB,oEAAoE;EACpE;;yCAEuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,kEAAkE;EAClE,aAAa;EACb,qBAAqB;EACrB,iBAAiB;EACjB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,8CAA8C;AAChD;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,uDAAuD;AACzD;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,mEAAmE;EACnE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mEAAmE;AACrE;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,UAAU;EACV,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;;EAEE,iBAAiB;EACjB,UAAU;EACV,mBAAmB;EACnB,kDAAkD;EAClD,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,UAAU;EACV,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;;EAEjB,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,sBAAsB;;EAEtB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,mCAAmC;EACnC,sBAAsB;AACxB;;AAEA;;EAEE,0EAA0E;AAC5E;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,qDAAqD;EACrD,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,wDAAwD;EACxD,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,kEAAkE;EAClE,oBAAoB;EACpB,4CAA4C;EAC5C,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,qBAAqB;EACrB,6CAA6C;EAC7C,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,uDAAuD;EACvD,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,YAAY;EACZ,mEAAmE;EACnE,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,sBAAsB;AACxB;;AAEA,gEAAgE;AAChE;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,8BAA8B;EAC9B,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,iBAAiB;EACjB,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,4DAA4D;EAC5D,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,SAAS;AACX;AACA;EACE,2BAA2B;EAC3B,wBAAwB;EACxB,SAAS;EACT,sCAAsC;AACxC;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;AACjB","sourcesContent":["@layer defaults {\n  :root {\n    --readthedocs-search-font-family: var(--readthedocs-font-family);\n    --readthedocs-search-font-size: var(--readthedocs-font-size); /* 16px? */\n    --readthedocs-search-code-font-family:\n      SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\",\n      monospace;\n    --readthedocs-search-code-font-size: 0.9em;\n\n    --readthedocs-search-backdrop-color: rgba(0, 0, 0, 0.3);\n    --readthedocs-search-color: rgb(64, 64, 64);\n    --readthedocs-search-link-color: rgb(64, 64, 64);\n\n    --readthedocs-search-content-background-color: #fcfcfc;\n    --readthedocs-search-content-border-color: #e0e0e0;\n    --readthedocs-search-filters-border-color: #e0e0e0;\n    --readthedocs-search-footer-background-color: rgb(234, 234, 234);\n    --readthedocs-search-footer-color: #404040;\n    --readthedocs-search-footer-code-background-color: #fff;\n    --readthedocs-search-footer-code-border-color: #e1e4e5;\n    --readthedocs-search-input-background-color: #eaeaea;\n\n    /* `--readthedocs-search-result-section-highlight-color` is deprecated but\n     * still support it for now. */\n    --readthedocs-search-result-highlight-color: var(\n      --readthedocs-search-result-section-highlight-color,\n      #6ea0ec\n    );\n    --readthedocs-search-result-background-color: initial;\n    /* `--readthedocs-search-result-section-color` is deprecated but\n     * still support it for now. */\n    --readthedocs-search-result-color: var(\n      --readthedocs-search-result-section-color,\n      rgba(0, 0, 0, 0.54)\n    );\n    --readthedocs-search-result-icon-color: rgba(0, 0, 0, 0.54);\n    --readthedocs-search-result-heading-color: rbg(0, 0, 0);\n    /* `--readthedocs-search-result-section-subheading-color` is deprecated but\n     * still support it for now. */\n    --readthedocs-search-result-subheading-color: var(\n      --readthedocs-search-result-section-subheading-color,\n      rgba(0, 0, 0, 0.64)\n    );\n    --readthedocs-search-result-active-background-color: rgb(245, 245, 245);\n    --readthedocs-search-result-border-color: rgb(224, 224, 224);\n    --readthedocs-search-badge-background-color: #e5f6ff;\n    --readthedocs-search-badge-color: rgba(0, 0, 0, 0.75);\n  }\n}\n\n:host > div {\n  font-family: var(--readthedocs-search-font-family);\n  font-size: var(--readthedocs-search-font-size);\n\n  /* TODO: make some of this variables */\n  color: var(--readthedocs-search-color);\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 3000;\n  line-height: 1rem;\n}\n\n:host > div a {\n  color: var(--readthedocs-search-link-color);\n  text-decoration: none;\n  cursor: pointer;\n}\n\n:host > div code {\n  background: var(--readthedocs-search-footer-code-background-color);\n  padding: 2px 5px;\n  border: solid 1px var(--readthedocs-search-footer-code-border-color);\n  color: var(--readthedocs-search-color);\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  font-family: var(--readthedocs-search-code-font-family);\n  font-size: var(--readthedocs-search-code-font-size);\n  border-radius: 0;\n}\n\n:host > div .background {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 1250;\n  width: 100%;\n  height: 100%;\n  background-color: var(--readthedocs-search-backdrop-color);\n  backdrop-filter: blur(3px);\n}\n\n:host > div > div.content {\n  margin: 5em auto auto auto;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 100000;\n  height: 80%;\n  width: 60%;\n  max-width: 43em;\n  overflow-y: hidden;\n  display: flex;\n  flex-direction: column;\n  border: 1px solid var(--readthedocs-search-content-border-color);\n  border-radius: 0.7rem;\n  line-height: 1.75rem;\n  background-color: var(--readthedocs-search-content-background-color);\n  box-shadow:\n    rgba(0, 0, 0, 0.05) 5px 5px 5px 5px,\n    rgba(0, 0, 0, 0.05) -5px -5px 5px 5px;\n  text-align: left;\n}\n\n:host > div form {\n  background-color: var(--readthedocs-search-input-background-color);\n  margin: 0.5em;\n  border-radius: 0.25em;\n  font-size: 1.05em;\n  padding: 5px;\n  display: flex;\n}\n\n:host > div form.focus {\n  outline: 2px solid #6ea0ec;\n  border-shadow: inset 0 0 1px white transparent;\n}\n\n:host > div form > label {\n  font-size: 1.15em;\n  padding-left: 5px;\n  color: var(--readthedocs-search-color);\n}\n\n:host > div form label svg {\n  height: 1em;\n  position: relative;\n  top: 5px;\n}\n\n:host > div form > input {\n  border: 0;\n  outline: none;\n  background: inherit;\n  width: max-content;\n  font-size: 1.15em;\n  box-shadow: none;\n  width: 100%;\n  padding: 6px;\n  line-height: 1;\n  color: var(--readthedocs-search-color, rgb(64, 64, 64));\n}\n\n:host > div .results {\n  margin-top: 10px;\n  padding: 0.5em;\n  overflow-y: scroll;\n  height: 100%;\n  hyphens: auto;\n}\n\ndiv.hit-block {\n  padding-top: 3px;\n  border-top: 1px solid var(--readthedocs-search-result-border-color);\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 10px;\n  background-color: var(--readthedocs-search-result-background-color);\n}\n\ndiv.hit-block a.hit-block-heading {\n  display: flex;\n  align-items: center;\n  width: 100%;\n}\n\ndiv.hit-block .hit-block-heading-container {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\ndiv.hit-block .hit-block-heading-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.5em;\n  width: 100%;\n  min-width: 0;\n}\n\ndiv.hit-block .hit-block-heading-row h2 {\n  flex-shrink: 0;\n  min-width: 0;\n}\n\ndiv.hit-block a.hit-block-heading i,\ndiv.hit-block .hit-block-heading-container .close-icon {\n  font-size: 1.15em;\n  width: 1em;\n  padding-right: 10px;\n  color: var(--readthedocs-search-result-icon-color);\n  padding-top: 5px;\n}\n\nbutton.close-icon {\n  border: none;\n  margin: 0;\n  padding: 0;\n  padding-right: 10px;\n  margin-bottom: 15px;\n  overflow: visible;\n\n  display: inline-block;\n  width: 1em;\n  height: 1em;\n  vertical-align: middle;\n\n  background: transparent;\n  cursor: pointer;\n}\n\nbutton.close-icon svg {\n  pointer-events: none;\n}\n\ndiv.hit-block a.hit-block-heading i svg,\ndiv.hit-block .hit-block-heading-container svg {\n  width: 1em;\n}\n\n:host > div .results a.hit {\n  width: 100%;\n  display: inline-block;\n  padding: 0.15em calc(1.15em + 10px);\n  box-sizing: border-box;\n}\n\n:host > div .results a.hit:hover,\n:host > div .results .hit .active {\n  background-color: var(--readthedocs-search-result-active-background-color);\n}\n\n:host > div .results h2 {\n  display: inline-block;\n  font-weight: 700;\n  margin-top: 3px;\n  margin-bottom: 5px;\n  font-size: 1em;\n  color: var(--readthedocs-search-result-heading-color);\n  line-height: inherit;\n}\n\n:host > div .results a.hit > div {\n  display: flex;\n  flex-direction: column;\n}\n\n:host > div .results .hit .subheading {\n  color: var(--readthedocs-search-result-subheading-color);\n  font-weight: 700;\n  font-size: 15px;\n  margin-right: 10px;\n  overflow-x: hidden;\n  margin: inherit;\n  line-height: inherit;\n}\n\n:host > div .results .project-badge {\n  align-items: center;\n  background-color: var(--readthedocs-search-badge-background-color);\n  border-radius: 999px;\n  color: var(--readthedocs-search-badge-color);\n  display: inline-flex;\n  font-size: 0.85em;\n  font-weight: 600;\n  line-height: 1;\n  padding: 0.25em 0.6em;\n  white-space: nowrap;\n  flex-shrink: 1;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n:host > div .results .hit .content {\n  margin: 0;\n  text-decoration: none;\n  color: var(--readthedocs-search-result-color);\n  font-size: 15px;\n  display: block;\n  margin-bottom: 5px;\n  margin-bottom: 0;\n  line-height: inherit;\n  text-align: left;\n}\n\n:host > div .results span {\n  font-style: normal;\n}\n\n:host > div .results .hit h2 span {\n  background-color: #e5f6ff;\n  padding-bottom: 3px;\n  border-bottom-color: black;\n}\n\n:host > div .results .hit span {\n  color: var(--readthedocs-search-result-highlight-color);\n  font-style: italic;\n  font-weight: bold;\n}\n\n:host div.content > div.footer {\n  width: 100%;\n  display: inline-block;\n  height: 30px;\n  background-color: var(--readthedocs-search-footer-background-color);\n  color: var(--readthedocs-search-footer-color);\n}\n\n:host > div .credits {\n  float: right;\n  margin: 0 15px;\n  font-size: small;\n  padding-top: 3px;\n}\n\n:host > div .credits a img {\n  display: inline-block;\n  width: 100px;\n  vertical-align: middle;\n}\n\n/* TODO: find an example for domain role and style it properly */\n:host > div .readthedocs-search-result-hit--domain-role {\n  font-size: 80%;\n  letter-spacing: 1px;\n}\n\n:host > div .filters-title {\n  display: block;\n  font-size: 0.9rem;\n  position: absolute;\n  top: 0;\n  left: 14px;\n  background: rgb(252, 252, 252);\n  margin: 0 5px;\n  padding: 0 5px;\n}\n\n:host > div .filters {\n  position: relative;\n  padding-top: 0.9rem;\n  margin: 0 0.5em;\n}\n\n:host > div .filters ul {\n  display: block;\n  margin: 0;\n  padding: 5px 14px;\n  border-radius: 0.3rem;\n  border-style: solid;\n  border-width: 1px;\n  border-color: var(--readthedocs-search-filters-border-color);\n  border-bottom: 1px solid #e0e0e0;\n}\n\n:host > div .filters li {\n  display: inline-block;\n  margin: 0 0 0 15px;\n}\n\n:host > div .filters li input {\n  vertical-align: middle;\n}\n\n:host > div .filters li label {\n  padding: 3px;\n  cursor: pointer;\n}\n\n:host > div .filters label {\n  font-size: 0.9rem;\n}\n\n:host > div .no-results {\n  text-align: center;\n  margin-top: 1.15em;\n  padding: 15px;\n  margin: 0 auto;\n  width: 80%;\n}\n\n:host > div .no-results > p.title {\n  margin-top: 0;\n  margin-bottom: 0.5em;\n}\n\n:host > div .no-results > svg {\n  height: 5.5rem;\n  margin-bottom: 1.15em;\n}\n\n:host > div .no-results > div.footer p {\n  font-size: small;\n}\n\n:host > div .no-results > .tips {\n  padding: 0;\n  text-align: left;\n  font-size: 15px;\n  margin-bottom: 1.15em;\n}\n\n:host > div .no-results > .tips ul {\n  padding: 0 0 0 0.7em;\n  margin: 0;\n}\n:host > div .no-results > .tips li {\n  list-style-position: inside;\n  list-style-type: \"\\BB  \";\n  margin: 0;\n  color: var(--readthedocs-search-color);\n}\n\n:host > div .help {\n  display: inline-block;\n  font-size: small;\n  margin: 0 15px;\n  padding: 0;\n}\n\n:host > div .help li {\n  list-style: none;\n  display: inline-block;\n  margin: 0 0.4em;\n}\n"],"sourceRoot":""}]);
// Exports
var ___CSS_LOADER_STYLE_SHEET___ = new CSSStyleSheet();
___CSS_LOADER_STYLE_SHEET___.replaceSync(___CSS_LOADER_EXPORT___.toString());
export default ___CSS_LOADER_STYLE_SHEET___;
